import * as React from "react";
const SvgFiBrandsPhotoshopLightroom = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-photoshop-lightroom_svg__a)">
      <path
        fill="#151A2D"
        d="M19.75.3H4.25C1.9.3 0 2.2 0 4.55v14.9c0 2.35 1.9 4.25 4.25 4.25h15.5c2.35 0 4.25-1.9 4.25-4.25V4.55C24 2.2 22.1.3 19.75.3m-6.7 14.65-.29 1.74c0 .05-.03.09-.06.12-.03.02-.06.03-.1.03H6.26c-.11 0-.16-.06-.16-.18V6.44c-.01-.07.04-.13.11-.14h2c.05-.01.11.03.11.08v8.43h4.62c.1 0 .13.05.11.14m5.96-4.17c0 .08-.05.11-.16.11-.65-.04-1.3.08-1.89.34-.2.09-.39.21-.54.37v5.1c0 .1-.04.14-.13.14h-1.95c-.08.01-.15-.04-.16-.12v-5.58c0-.24 0-.49-.01-.75s-.01-.52-.02-.78q-.015-.33-.06-.66c-.01-.05.02-.1.07-.11.01-.01.02-.01.04 0h1.75c.1 0 .18.07.21.16.04.07.07.15.08.23a3.3 3.3 0 0 1 .07.67c.3-.35.66-.64 1.07-.86.46-.25.97-.37 1.49-.36.07-.01.13.04.14.11z"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-photoshop-lightroom_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsPhotoshopLightroom;
